export let adds = {
  K: {
    key: 'K',
    label: 'Korektor zapisów księgowych',
    description:
      'Bardzo użyteczny dodatek, który umożliwia dokonywanie zmian, poprawek i usuwanie zapisów księgowych ' +
      'oraz inne modyfikacje danych (np. usunięcie konta), a także odblokowanie programu, ' +
      'gdy zapomnisz hasła dostępu.',
  },
  X: {
    key: 'X',
    label: 'Wymiana danych',
    description: '',
  },
  A: {
    key: 'A',
    label: 'Samodzielne wpisywanie danych',
    description:
      'Umożliwia samodzielne wpisywanie i zmienianie danych adresowych oraz NIP-u, używanych przy fakturowaniu, poleceniach przelewu i przekazu, adresowaniu pism, kopert itp. Dane te mogą być różne w każdym zestawie danych (Firmie). Przydatne, jeżeli dane często ulegają zmianie, dla firm wielozakładowych oraz gdy użytkownik prowadzi więcej działalności.',
  },
  S: {
    key: 'S',
    label: 'Wersja wielostanowiskowa',
    description:
      'Umożliwia wielostanowiskową pracę w sieci - obsługa dowolnej Firmy z dowolnego stanowiska. Uprawnia też do niezależnej instalacji programu na wielu komputerach należących do właściciela programu i przez niego użytkowanych, połączonych lub niepołączonych siecią. Uwaga. Przy pracy w sieci w danej chwili dwa stanowiska nie mogą uzyskać jednocześnie dostępu do danych tej samej Firmy.',
  },
  O: {
    key: 'O',
    label: 'Wersja ograniczona',
    description:
      'Wersja ograniczona przeznaczona jest klientów biura rachunkowego, które używa programu SKP<sup>®</sup> z dodatkiem WYMIANA DANYCH. Służy głównie do wystawiania faktur sprzedaży, a następnie do okresowego przekazywania danych do biura rachunkowego. Jednocześnie może ona pobierać z biura rachunkowego kompletne, opracowane dane za kolejne miesiące. Dodatkowo posiada funkcję wysyłania danych w celu komunikacji z biurem.\n' +
      'Użytkownicy tej wersji programu mogą generować pliki JPK_FA i wysyłać je do biura rachunkowego oraz na serwery Ministerstwa Finansów.',
  },
  J: {
    key: 'J',
    label: 'Import plików JPK',
    description: '',
  },
};

export let a_skp_F = ['K', 'A', 'J', 'X'];
export let a_skp_B = ['K', 'J', 'X', 'O', 'S'];
export let a_skp_O = ['O'];
export let a_sam = ['K'];
export let a_all = ['K', 'A', 'J', 'X', 'O', 'S'];
